<template lang="html">
  <section class="agreement" v-loading="fullLoading">
    <row>
      <div class="sl-col-4">
        <div class="sl-agreement">
          <p class="title">{{$t('Views.Agreement.title')}}</p>
          <div class="error-msg" v-if="errorMsg !== ''">{{errorMsg}}</div>
          <div v-else class="sl-table-sm" v-for="item in list">
            <ul>
              <li style="position:relative;"><img :src="`/static/imgs/T-${item.channelId}.png`" alt="" ><span>{{item.channelName}}</span></li>
              <li><span>{{item.settleWay}}+{{item.settlePeriod}}</span></li>
              <li><span>{{(item.rate/100).toFixed(2)}}%</span></li>
            </ul>
          </div>
          <div class="btn" @click="confirm">{{$t('Functional.next')}}</div>
        </div>
      </div>
    </row>

  </section>
</template>

<script>
import api from '../../api'
export default {
  data() {
    return {
      fullLoading: false,
      list: [],
      errorMsg: ''
    }
  },
  created() {
    const vm = this
    this.fullLoading = true
    api.ShowChannel().then(res => {
      if (res.data.code === 200) {
        vm.list = res.data.data.list
      } else {
        vm.errorMsg = res.data.msg
      }
      vm.fullLoading = false
    })
  },
  methods: {
    confirm() {
      this.$ga.event('Link', 'Confirm', 'Agreement')
      this.$router.push({
        name: 'OB-Contract'
      })
    },
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    }
  }
}
</script>

<style scoped>
.sl-agreement {
  background: #FFFFFF;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.10);
  border-radius: 2px;
  text-align: center;
  max-width: 700px;
  margin: 40px auto 0;
}

.sl-agreement .title {
  font-family: Avenir-Book;
  font-size: 16px;
  color: #4A4A4A;
  line-height: 16px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.sl-radio {
  display: flex;
  padding-left: 150px;
  padding-bottom: 15px;
}

.sl-table-sm {
  text-align: center;
  padding: 15px 0 10px;
  max-width: 700px;
  position: relative;
  left: 60px;
}

.sl-table-sm img {
  width: 20px;
  height: 20px;
  display: inline-block;
  position: relative;
  top: -1px;
  left: -5px;
}

.sl-table-sm span,
.sl-table-sm ul,
.sl-table-sm ul li {
  display: inline-block;
  text-align: left;
}

.sl-table-sm ul {
  padding: 0;
}

.sl-table-sm ul li {
  width: 150px;
}

.sl-label {
  width: 150px;
  margin: 0 !important;
}

.btn {
  background: #2B90E9;
  border-radius: 2px;
  width: 140px;
  height: 36px;
  font-family: Avenir-Medium;
  font-size: 14px;
  color: #FFFFFF;
  margin-top: 40px;
  margin-bottom: 25px;
}

.tips {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #9B9B9B;
  line-height: 20px;
  padding-bottom: 50px;
}

.error-msg {
  max-width: 500px;
  margin: 0 auto;
  word-wrap: break-word;
  word-break: normal;
}
</style>



// WEBPACK FOOTER //
// agreement.vue?08017080